import { useTranslation } from "react-i18next";
import "./AdvanceSetting.scss";
// import { SearchTypeSelect } from "ui-components";
import TimeInput from "../../../../../components/TimeSelector/TimeInput";
import { useEffect, useState } from "react";

interface Props {
  startMeridiem: string;
  endMeridiem: string;
  onStartTimeChange: (e: string) => void;
  onEndTimeChange: (e: string) => void;
  onStartMeridiemChange: (e: string) => void;
  onEndMeridiemChange: (e: string) => void;
  startTime: string;
  endTime: string;
}

const ShiftTime = ({
  startMeridiem,
  endMeridiem,
  onStartTimeChange,
  onEndTimeChange,
  onStartMeridiemChange,
  onEndMeridiemChange,
  startTime,
  endTime,
}: Props) => {
  const { t } = useTranslation();
  const [startHour, setStartHour] = useState(10);
  const [startMinute, setStartMinute] = useState("00");
  const [endHour, setEndHour] = useState(7);
  const [endMinute, setEndMinute] = useState("00");
  useEffect(() => {
    const [hour, minute] = startTime?.split(":") || [];
    const parsedHour = Number(hour);
    const parsedMinute = minute || "00";

    if (
      !isNaN(parsedHour) &&
      (parsedHour !== startHour || parsedMinute !== startMinute)
    ) {
      setStartHour(parsedHour);
      setStartMinute(parsedMinute);
    }
  }, [startTime]);

  useEffect(() => {
    const [hour, minute] = endTime?.split(":") || [];
    const parsedHour = Number(hour);
    const parsedMinute = minute || "00";

    if (
      !isNaN(parsedHour) &&
      (parsedHour !== endHour || parsedMinute !== endMinute)
    ) {
      setEndHour(parsedHour);
      setEndMinute(parsedMinute);
    }
  }, [endTime]);

  return (
    <div className="shiftTimeSec">
      <span className="comSubLabel">{t("RESUME.SHIFT_TIMING")}</span>
      <div className="shiftTimerow mt-3">
        <div className="rtlGap">
          <p className="shiftTimeLabels">{t("GENERAL.START_TIME")}</p>
          <div className="timeInput">
            <TimeInput
              onTimeChange={onStartTimeChange}
              setAmPm={onStartMeridiemChange}
              amPm={startMeridiem}
              hour={startHour}
              setHour={setStartHour}
              minute={startMinute}
              setMinute={setStartMinute}
            />
          </div>
        </div>

        <div className="rtlGap">
          <p className="shiftTimeLabels">{t("GENERAL.END_TIME")}</p>
          <div className="timeInput">
            <TimeInput
              onTimeChange={onEndTimeChange}
              setAmPm={onEndMeridiemChange}
              amPm={endMeridiem}
              hour={endHour}
              setHour={setEndHour}
              minute={endMinute}
              setMinute={setEndMinute}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShiftTime;
